import { Chart } from "primereact/chart";

import { formatMeters } from "./formatters";

const colors = {
  real: "#2563eb",
  simple: "#16a34a",
  weighted: "#ea580c",
  exponential: "#9333ea",
  seasonal: "#dc2626",
  winters: "#0891b2",
};

const compactNumber = new Intl.NumberFormat("pt-BR", { maximumFractionDigits: 0 });

const LABEL_HEIGHT = 16;
const LABEL_GAP = 2;
const POINT_OFFSET = 12;

const drawPill = (ctx, x, y, width, height, color) => {
  ctx.beginPath();
  if (ctx.roundRect) ctx.roundRect(x - width / 2, y - height / 2, width, height, 4);
  else ctx.rect(x - width / 2, y - height / 2, width, height);
  ctx.fillStyle = color;
  ctx.fill();
};

// Plugin local: desenha o valor acima de cada bolinha, empilhando rótulos
// do mesmo mês para que não se sobreponham.
const valueLabelsPlugin = {
  id: "valueLabels",
  afterDatasetsDraw(chart, _args, options) {
    if (!options?.enabled) return;
    
    const { ctx, chartArea } = chart;
    const byIndex = {};
    
    chart.data.datasets.forEach((dataset, datasetIndex) => {
      if (!chart.isDatasetVisible(datasetIndex)) return;
      const meta = chart.getDatasetMeta(datasetIndex);
      
      meta.data.forEach((point, index) => {
        const value = dataset.data[index];
        if (value === null || value === undefined || Number.isNaN(value)) return;
        if (dataset.labelOnlyFuture && index < options.historyLength) return;
        
        (byIndex[index] ||= []).push({
          x: point.x,
          y: point.y,
          text: compactNumber.format(value),
          color: dataset.borderColor,
        });
      });
    });
    
    ctx.save();
    ctx.font = "600 10px sans-serif";
    ctx.textAlign = "center";
    ctx.textBaseline = "middle";
    
    Object.values(byIndex).forEach((items) => {
      // Do ponto mais baixo (maior y) para o mais alto: os rótulos sobem em pilha.
      items.sort((a, b) => b.y - a.y);
      
      let previousY = Infinity;
      items.forEach((item) => {
        let labelY = Math.min(item.y - POINT_OFFSET, previousY - LABEL_HEIGHT - LABEL_GAP);
        labelY = Math.max(labelY, chartArea.top - LABEL_HEIGHT / 2);
        previousY = labelY;
        
        const width = ctx.measureText(item.text).width + 8;
        drawPill(ctx, item.x, labelY, width, LABEL_HEIGHT, item.color);
        ctx.fillStyle = "#ffffff";
        ctx.fillText(item.text, item.x, labelY + 0.5);
      });
    });
    
    ctx.restore();
  },
};
const chartPlugins = [valueLabelsPlugin];

const GraficoPrevisao = ({ series, futureLabels, methods = [], showValues = false }) => {
  const labels = [...series.map((item) => item.label), ...futureLabels];
  const datasets = [{
    label: "Saída real",
    data: [...series.map((item) => item.value), ...Array(futureLabels.length).fill(null)],
    borderColor: colors.real,
    backgroundColor: "rgba(37, 99, 235, 0.10)",
    fill: false,
    tension: 0.25,
  }];

  methods.filter(Boolean).forEach(({ key, method }) => {
    datasets.push({
      label: method.label,
      data: [...method.fitted, ...method.future],
      borderColor: colors[key],
      backgroundColor: colors[key],
      borderDash: [5, 4],
      fill: false,
      tension: 0.25,
    });
  });

  return (
    <div style={{ height: "28rem" }}>
      <Chart
        type="line"
        data={{ labels, datasets }}
        plugins={chartPlugins}
        options={{
          maintainAspectRatio: false,
          layout: {
            padding: {
              top: showValues ? 28 : 0,
              right: showValues ? 28 : 0,
            },
          },
          plugins: {
            valueLabels: { enabled: showValues, historyLength: series.length },
            tooltip: {
              callbacks: {
                label: (context) =>
                  `${context.dataset.label}: ${formatMeters(context.parsed.y)}`,
              },
            },
          },
          scales: { y: { ticks: { callback: formatMeters } } },
        }}
        style={{ height: "28rem" }}
      />
    </div>
  );
};

export default GraficoPrevisao;